import React, { useMemo, useState } from 'react'
import EntityList from './Components/EntityList'
import useManageEntities from './useManageEntities'
import * as entityHeading from '../../Constants/Constants'
import Style from './manageEntities.module.css'

const ManageEntities = (props) => {
    const {
        entities,
        isLoading,
        loadError,
        savingId,
        status,
        toggleEntity,
        dismissStatus,
        reload
    } = useManageEntities(props.connectorId, props.instancesId)

    const [searchTerm, setSearchTerm] = useState('')

    const visibleEntities = useMemo(() => {
        const term = searchTerm.trim().toLowerCase()
        if (term === '') {
            return entities
        }
        return entities.filter((entity) => entity.displayName.toLowerCase().includes(term))
    }, [entities, searchTerm])

    const activeCount = useMemo(
        () => entities.filter((entity) => entity.isInboundActive || entity.isOutboundActive).length,
        [entities]
    )

    const showToolbar = !isLoading && !loadError && entities.length > 0

    return (
        <div className='col-lg-12'>
            <div className='card mndesc'>
                <div className={`card-header ${Style.header}`}>
                    <div className={Style.headerTitle}>
                        <span>{entityHeading.entityHeading.mainHeading}</span>
                        {showToolbar ? (
                            <span className={Style.countChip}>{activeCount} of {entities.length} active</span>
                        ) : null}
                    </div>
                    {showToolbar ? (
                        <div className={Style.search}>
                            <i className={`uil-search ${Style.searchIcon}`} aria-hidden="true" />
                            <input
                                type="search"
                                className={Style.searchInput}
                                placeholder="Search entities"
                                aria-label="Search entities"
                                value={searchTerm}
                                onChange={(event) => setSearchTerm(event.target.value)}
                            />
                        </div>
                    ) : null}
                </div>

                <div className={`card-body ${Style.body}`}>
                    {status ? (
                        <div
                            className={[Style.banner, status.result ? Style.bannerSuccess : Style.bannerError].join(' ')}
                            role={status.result ? 'status' : 'alert'}
                        >
                            <i
                                className={status.result ? 'uil-check-circle' : 'uil-exclamation-triangle'}
                                aria-hidden="true"
                            />
                            <span className={Style.bannerText}>{status.message}</span>
                            <button
                                type="button"
                                className={Style.bannerClose}
                                aria-label="Dismiss message"
                                onClick={dismissStatus}
                            >
                                &times;
                            </button>
                        </div>
                    ) : null}

                    <EntityList
                        entities={visibleEntities}
                        totalCount={entities.length}
                        isLoading={isLoading}
                        loadError={loadError}
                        savingId={savingId}
                        searchTerm={searchTerm.trim()}
                        onToggle={toggleEntity}
                        onRetry={reload}
                        onClearSearch={() => setSearchTerm('')}
                    />
                </div>
            </div>
        </div>
    )
}

export default ManageEntities
